import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "relative h-screen flex flex-col items-center justify-center bg-gradient-to-br from-white via-purple-50 to-pink-50" }
const _hoisted_2 = { class: "w-full max-w-lg px-6 flex flex-col items-center justify-center gap-3" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col gap-3"
}
const _hoisted_4 = {
  key: 0,
  class: "text-xs text-red-600 bg-red-100 px-3 py-2 rounded-lg"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 1,
  class: "flex flex-col items-center gap-4"
}
const _hoisted_7 = { class: "flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-purple-100/50 to-purple-100/10 text-purple-500 shadow-inner border border-purple-100" }
const _hoisted_8 = {
  key: 0,
  class: "mt-4 text-sm text-green-700 bg-green-50 px-4 py-3 rounded-xl"
}
const _hoisted_9 = {
  key: 1,
  class: "text-xs text-red-600 bg-red-100 px-3 py-2 rounded-lg w-full"
}

import { ref } from "vue";
import axios from "@/services/api";
import { getConfigValue } from "@/core/config";
import * as Yup from "yup";
import { useField, useForm } from "vee-validate";
import token_service from "@/services/token_service";
import { useRoute } from "vue-router";
import { Check } from "lucide-vue-next";
import FormInput from "@/components/auth/FormInput.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  setup(__props) {

const router = useRoute();
const isLoading = ref(false);
const isSubmitted = ref(false);
const errorMessage = ref("");
const successMessage = ref("");
const passwordStrengthSchema = Yup.string()
  .min(6, 'Password must be at least 6 characters')
  .max(24, 'Password must be at most 24 characters')
  .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
  .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
  .matches(/[0-9]/, 'Password must contain at least one number')
  .matches(/[^A-Za-z0-9]/, 'Password must contain at least one special character')
  .test('no-spaces', 'Password cannot contain spaces', value => !/\s/.test(value ?? ''))

const schema = Yup.object().shape({
  password: passwordStrengthSchema.required("Password is required"),
  confirmPassword: Yup.string()
    .trim()
    .required("Repeat the password in order to confirm it")
    .oneOf([Yup.ref("password"), ""], "Passwords must match"),
});

const { handleSubmit } = useForm({ validationSchema: schema })

const {
  value: password,
  errorMessage: passwordError,
  meta: passwordMeta,
} = useField<string>("password");

const {
  value: confirmPassword,
  errorMessage: confirmPasswordError,
  meta: confirmPasswordMeta,
} = useField<string>("confirmPassword");


const handlePasswordReset = handleSubmit(() => {
  isLoading.value = true;
  axios
    .post("user/resetPassword", {
      token:
        router.params.token /* router.currentRoute.value.query.token */,
      newPassword: password.value,
    })
    .then((res) => {
      if (res.status === 200) {
        isSubmitted.value = true;
        isLoading.value = false;
        successMessage.value =
          "Your password reseted successfully ! You will be authenticated in few seconds";
        setTimeout(() => {
          const user = res.data.data.user;
          user.accessToken = res.data.data.token;
          token_service.setUser(user);
          window.location.href = `${getConfigValue(
            "TALENTS_DOMAINE"
          ) || 'https://app-contentfactory.tawa.digital/'}/?token=${user.accessToken}`;
        }, 2000);
      }
    })
    .catch((e) => {
      const res = e.response;
      errorMessage.value = res.data.error
      isSubmitted.value = true;
      isLoading.value = false;
    });
})


return (_ctx: any,_cache: any) => {
  const _component_LoaderCircle = _resolveComponent("LoaderCircle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "absolute top-6 left-6" }, [
      _createElementVNode("img", {
        src: _imports_0,
        class: "w-[85px] h-auto",
        alt: "Logo"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (!isSubmitted.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mb-4" }, [
              _createElementVNode("h2", { class: "text-2xl font-semibold text-gray-600" }, " Set a New Password "),
              _createElementVNode("p", { class: "text-sm text-gray-400 mt-2" }, " Your new password must be different from your previous one. ")
            ], -1)),
            _createVNode(FormInput, {
              label: "Password",
              modelValue: _unref(password),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
              type: "password",
              placeholder: "Enter your password",
              error: _unref(passwordMeta).touched ? _unref(passwordError) : ''
            }, null, 8, ["modelValue", "error"]),
            _createVNode(FormInput, {
              label: "Confirm Password",
              modelValue: _unref(confirmPassword),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(confirmPassword) ? (confirmPassword).value = $event : null)),
              type: "password",
              placeholder: "Confirm your password",
              error: _unref(confirmPasswordMeta).touched ? _unref(confirmPasswordError) : ''
            }, null, 8, ["modelValue", "error"]),
            (errorMessage.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(errorMessage.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              disabled: isLoading.value,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(handlePasswordReset) && _unref(handlePasswordReset)(...args))),
              class: "w-full mt-4 bg-gradient-to-r from-purple-500 to-pink-400 text-white font-semibold py-3 rounded-xl hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
            }, [
              (isLoading.value)
                ? (_openBlock(), _createBlock(_component_LoaderCircle, {
                    key: 0,
                    class: "w-4 h-4 animate-spin"
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(isLoading.value ? 'Resetting password...' : 'Reset Password'), 1)
            ], 8, _hoisted_5),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'login' }))),
              class: "text-sm text-gray-500 hover:underline text-center"
            }, " ← Back to Sign In ")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(Check), { class: "w-5 h-5" })
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "text-xl font-semibold text-gray-600" }, " Your password has been reset! ", -1)),
            (successMessage.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(successMessage.value), 1))
              : _createCommentVNode("", true),
            (errorMessage.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(errorMessage.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ name: 'login' }))),
              class: "w-full mt-6 bg-gradient-to-r from-purple-500 to-pink-400 text-white font-semibold py-3 rounded-xl flex justify-center"
            }, " Back to Login ")
          ]))
    ])
  ]))
}
}

})